import React from 'react';
import cn from 'classnames';

import { ICheckboxContentProps } from './CheckboxContent.types';

import Checkbox from '../../Checkbox';

import './CheckboxContent.scss';

const CheckboxContent: React.FC<ICheckboxContentProps> = ({
	addAllOptions,
	checkboxLabel,
	disabled,
	isInLine,
	name,
	options,
	readOnly,
	removeAllOptions,
	selectedListOfOptions,
}) => {
	const onChangeCheckbox = () => {
		if (selectedListOfOptions.length) {
			removeAllOptions();
		} else addAllOptions();
	};

	return (
		<div className={cn('f5gCheckboxContentContainer', { 'f5gCheckboxContentContainerInLine': isInLine })}>
			<Checkbox
				checked={!!selectedListOfOptions.length}
				disabled={!options.length || disabled}
				label={checkboxLabel}
				name={name}
				onChange={onChangeCheckbox}
				readOnly={readOnly}
			/>
		</div>
	);
};

export default CheckboxContent;
